import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useAuthState } from 'react-firebase-hooks/auth'
import { FirebaseAuth } from '@/services'
import { Request, ScrollTop, Translation } from '@/helpers'
import { CategoryState, ComponentState, SideoverState, TagState } from '@/states'

import {
    COMPONENT_DEFUALT_FILTERS,
    COMPONENT_DEFAULT_ERRORS,
    COMPONENT_DEFAULT_FORM,
    ENDPOINTS
} from '@/data'

const AuthHandler = (User: UserInterface | null, SetState: Function, Notification: Function) => {
    const { push } = useRouter()

    const { SetState: SideoverSetState } = SideoverState()
    const { SetState: CategorySetState } = CategoryState()
    const { SetState: TagSetState } = TagState()
    const { SetState: ComponentSetState } = ComponentState()

    const [allow, setAllow] = useState(true)
    const [user, loading] = useAuthState(FirebaseAuth) as any

    const Authenticator = async () => {
        const formatted_domain_of_email = user?.email?.split('@')[1]
        let isVaild = formatted_domain_of_email?.toLowerCase() === 'azwedo.com'

        if (user?.email === 'blodinselimi@gmail.com') isVaild = true
        if (user?.email === 'donatbytyqi2@gmail.com') isVaild = true

        if (isVaild) {
            const response = await Request({
                path: ENDPOINTS.AUTH,
                method: 'POST',
                body: {
                    name: user.displayName,
                    email: user.email,
                    avatar: user.photoURL
                }
            })

            if (response) {
                const { success, data, message } = response

                if (success) SetState({
                    User: data,
                    Loading: false
                })

                else {
                    ScrollTop()

                    await FirebaseAuth.signOut()

                    SetState({
                        User: false,
                        Loading: false
                    })

                    SideoverSetState({
                        Form: COMPONENT_DEFAULT_FORM,
                        Errors: COMPONENT_DEFAULT_ERRORS,
                        Open: false,
                        Loading: false
                    })

                    CategorySetState({
                        Categories: [],
                        Loading: false
                    })

                    TagSetState({
                        Categories: [],
                        Loading: false
                    })

                    ComponentSetState({
                        Components: [],
                        Loading: false,
                        Filters: COMPONENT_DEFUALT_FILTERS
                    })

                    Notification(message)

                    push('/')
                }
            }

            else {
                ScrollTop()

                await FirebaseAuth.signOut()

                SetState({
                    User: false,
                    Loading: false
                })

                SideoverSetState({
                    Form: COMPONENT_DEFAULT_FORM,
                    Errors: COMPONENT_DEFAULT_ERRORS,
                    Open: false,
                    Loading: false
                })

                CategorySetState({
                    Categories: [],
                    Loading: false
                })

                TagSetState({
                    Tags: [],
                    Loading: false
                })

                ComponentSetState({
                    Components: [],
                    Loading: false,
                    Filters: COMPONENT_DEFUALT_FILTERS
                })

                Notification(Translation('something-went-wrong-while-trying-to-auth-the-user'))

                push('/')
            }
        }

        else {
            ScrollTop()

            await FirebaseAuth.signOut()

            SetState({
                User: false,
                Loading: false
            })

            SideoverSetState({
                Form: COMPONENT_DEFAULT_FORM,
                Errors: COMPONENT_DEFAULT_ERRORS,
                Open: false,
                Loading: false
            })

            CategorySetState({
                Categories: [],
                Loading: false
            })

            TagSetState({
                Categories: [],
                Loading: false
            })

            ComponentSetState({
                Components: [],
                Loading: false,
                Filters: COMPONENT_DEFUALT_FILTERS
            })

            Notification(Translation('only-internal-emails-are-allowed-to-use-the-app'))

            push('/')
        }
    }

    useEffect(() => {
        if (!loading && allow) {
            if (!user && !User) {
                ScrollTop()

                FirebaseAuth.signOut()

                setAllow(false)

                SetState({
                    Loading: false,
                    User: false
                })

                SideoverSetState({
                    Form: COMPONENT_DEFAULT_FORM,
                    Errors: COMPONENT_DEFAULT_ERRORS,
                    Open: false,
                    Loading: false
                })

                CategorySetState({
                    Categories: [],
                    Loading: false
                })

                ComponentSetState({
                    Components: [],
                    Loading: false,
                    Filters: COMPONENT_DEFUALT_FILTERS
                })

                push('/')
            }

            if (user && !User) {
                setAllow(false)
                Authenticator()
            }
        }
    }, [user, loading])
}

export default AuthHandler
